import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  data: {},
  loading: false,
})

const { Types, Creators } = createActions({
  setUnavailableItemLoading: ['val'],
  setUnavailableItem: ['merchantKey', 'data'],
  getUnavailableItems: ['merchantKey'],
})

export const setUnavailableItemLoadingReducer = state => state.set('loading', true)

export const setUnavailableItemReducer = (state, { merchantKey, data }) =>
  state.setIn(['data', merchantKey], data).set('loading', false)

export const getUnavailableItemsReducer = state => state.set('loading', true)

export const unavailableItemReducer = createReducer(INITIAL_STATE, {
  [Types.SET_UNAVAILABLE_ITEM]: setUnavailableItemReducer,
  [Types.GET_UNAVAILABLE_ITEMS]: getUnavailableItemsReducer,
  [Types.SET_UNAVAILABLE_ITEM_LOADING]: setUnavailableItemLoadingReducer,
})

export const UnavailableItemTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/unavailableItemReducer.js